module.exports = __webpack_public_path__ + "img/zgjb.74fed37b.jpg";